import { Button, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutUnassignEquipmentPrompt extends Layout {
    buttonNo: Button;
    buttonYes: Button;
    panelMessage: Panel;
    panelUnassignEquipment: Panel;
    panelUnassignReason: Panel;
    panelYesNoButtons: Panel;
    sourceReasonCode: DataSource;
    textboxComments: Textbox;
    textboxReasonCode: Textbox;
}
